export enum Role {
    ADMIN = 'br_admin',
    BR_HR = 'br_hr',
    ZOLTAN = 'zoltan',
    UGYINTEZO = 'ugyintezo',
    FOVEZENYLO = 'fovezenylo',
    VEZENYLO = 'vezenylo',
    DOLGOZO_HR = 'dolgozo_hr',
    DOLGOZO_MUSZAKVEZ = 'dolgozo_muszakvez',
    MENETRENDI_ADATROGZITO = 'menetrendi_adatrogzito',
}

export const isReadOnlyRole = (roles: Array<String>): boolean => {
    for (const role of Object.values(Role)) {
        if (role !== Role.MENETRENDI_ADATROGZITO && roles.includes(role)) {
            return false;
        }
    }
    return true;
};

export type User = {
    username: string;
    name: string;
    email: string;
    roles: [Role];
    accessToken: string | null;
    refreshToken: string | null;
    exp: number;
    refreshExp: number;
    workplace?: string;
    hasRole: (role: Role) => boolean;
    isRefreshTimeExpired: () => boolean;
};

export type RealmAttribute = {
    roles: [Role];
};

export type AuthPayload = {
    preferred_username: string;
    name: string;
    email: string;
    iat: number;
    exp: number;
    family_name: string;
    given_name: string;
    realm_access: RealmAttribute;
    workplace?: string;
};

export type AuthContextType = {
    user: User | undefined;
    isAuthenticated: boolean;
    isLoading: boolean;
    signOut: () => void;
    signIn: (accessToken: string, refreshToken: string) => void;
    getValidToken: () => Promise<string | undefined>;
};
